// extracted by mini-css-extract-plugin
module.exports = {"expandListButton":"AccordionButton_expandListButton__2Aebt","expandIcon":"AccordionButton_expandIcon__1jUDO","expanded":"AccordionButton_expanded__S7-7B"};